export default "__VITE_ASSET__D9UnwnN3__"